import { jsx as y } from "react/jsx-runtime";
import { C as E, a as _ } from "../../index-Bo5fc4VO.js";
import { forwardRef as u } from "react";
import S from "./hooks/usePopover.js";
import { PopoverContext as b } from "./hooks/usePopoverContext.js";
import { MarketPopoverContent as k } from "./subcomponents/MarketPopoverContent.js";
import { MarketPopoverTrigger as A } from "./subcomponents/MarketPopoverTrigger.js";
const I = (r, t) => {
  const {
    children: o,
    container: n = "div",
    disableFocusManager: p = !1,
    interaction: a,
    layerMode: i = "portal",
    viewportMargin: s = E,
    offset: l = _,
    onCloseEnd: c,
    onCloseStart: f,
    onOpenEnd: m,
    onOpenStart: v,
    placement: P = "bottom",
    portalRootId: d,
    role: M = "dialog",
    strategy: C = "absolute",
    ...O
  } = r, R = Object.prototype.hasOwnProperty.call(HTMLElement.prototype, "popover"), g = i === "native" && R ? "native" : "portal", e = S({
    interaction: a,
    viewportMargin: s,
    offset: l,
    placement: P,
    popoverRef: t,
    role: M,
    strategy: C,
    ...O
  });
  return /* @__PURE__ */ y(
    b.Provider,
    {
      value: {
        container: n,
        disableFocusManager: p,
        layerMode: g,
        onCloseEnd: c,
        onCloseStart: f,
        onOpenEnd: m,
        onOpenStart: v,
        portalRootId: d,
        ...e
      },
      children: typeof o == "function" ? o({ setPositionReference: e.refs.setPositionReference }) : o
    }
  );
}, H = Object.assign(u(I), {
  displayName: "MarketPopover",
  Trigger: A,
  Content: k
});
export {
  H as MarketPopover
};
